var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard3IconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11066",
    "data-name": "Group 11066",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4214",
    "data-name": "Rectangle 4214",
    width: 70,
    height: 70,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11065",
    "data-name": "Group 11065",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M39.047,58.23a26.8,26.8,0,0,1,17.42,5.365c.549.423,2.7,2.058,2.542,2.7a.868.868,0,0,1-1.24.462,24.9,24.9,0,0,0-40.139,8.239c-7.792,18.559,8.675,38.02,28.252,33.767,15.66-3.4,23.936-21.022,16.73-35.4-.422-.842-2.071-2.98-2.224-3.519-.311-1.1.839-1.485,1.787-.288,4.973,6.279,5.772,16.686,3.1,24.03-7.078,19.484-33.181,23.549-45.791,6.99C6.681,83.756,18.075,59.338,39.047,58.23",
    transform: "translate(-11.105 -45.851)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M78.273,94.363a.83.83,0,0,1-.843,1.393c-.207-.058-2.341-1.83-2.926-2.181-17.846-10.691-36.636,12.181-22.9,27.565,13.211,14.792,37.5.24,30.344-18.677-.284-.75-3.266-5.38-1-4.733,1.627.465,3.616,7.541,3.752,9.2,1.855,22.646-28.5,30.107-37.512,10.36-7.974-17.477,11.354-34.94,27.822-25.277a22.507,22.507,0,0,1,3.262,2.355",
    transform: "translate(-35.718 -70.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M165.944,23.509c.548.567.312,4.472.691,5.463.8-.58,1.477-1.814,2.3-.485v.545l-1.242,1.211c1.312.491,3.97.563,5.079,1.179a.723.723,0,0,1,.43.62l-.327.735-9.4,7.965c-.946.2-4.629-1.271-5.918-1.339a.709.709,0,0,0-.587.152L136.206,57.619c-1.091.638-1.816-.119-1.194-1.193l20.814-18c.745-1.3-.643-5.29-.114-6.9l9.575-8.225a.958.958,0,0,1,.657.212m-8.183,14.333,5.489,1.2,7.2-6.354-5.2-1.586-.528-5.308-7.312,6.368a19.97,19.97,0,0,0,.352,5.684",
    transform: "translate(-106.192 -18.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M98.177,123.774a.823.823,0,0,1-.475,1.432c-1.186-.424-2.025-1.322-3.279-1.81-10.676-4.153-20.22,7.917-13.665,17.271,7.332,10.462,24.554,2.3,20.035-10.7-.409-1.175-2.024-2.9.273-2.867,7.844,12.3-7.894,26.354-19.255,16.97-9.9-8.176-3.17-24.226,9.512-23.088,1.705.153,5.764,1.475,6.854,2.793",
    transform: "translate(-60.713 -95.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M113.673,152.967c1.254-.212,5.538-.214,4.164,1.848-.48.352-1.819-.39-2.528-.42a4.8,4.8,0,0,0-4.006,7.63c2.5,3.491,8.246,1.806,8.581-2.426.061-.772-.374-1.9-.112-2.436.447-.907,1.373-.214,1.548.573a6.371,6.371,0,0,1-9.7,6.725c-4.621-2.906-3.224-10.6,2.048-11.493",
    transform: "translate(-85.743 -120.448)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard3IconLight);
export default __webpack_public_path__ + "static/media/card3_icon_light.7004127e3f737507b99b068f34ad6fa9.svg";
export { ForwardRef as ReactComponent };